import { render, staticRenderFns } from "./LoginBtnComp.vue?vue&type=template&id=1d840d09&scoped=true"
import script from "./LoginBtnComp.vue?vue&type=script&lang=ts"
export * from "./LoginBtnComp.vue?vue&type=script&lang=ts"
import style0 from "./LoginBtnComp.vue?vue&type=style&index=0&id=1d840d09&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d840d09",
  null
  
)

export default component.exports